import { EcrDefinitionsInfo } from "@/model/data/ecr/EcrDefinitionsInfo";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";


export class GetDistinctEcrCodesResData extends ServiceResponseData {

    public ecrCodes: EcrDefinitionsInfo[];

    constructor(response: AxiosResponse) {
        super(response);
        this.ecrCodes = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.EcrCodes && obj.EcrCodes.length > 0) {
            obj.EcrCodes.forEach(e => {
                var ecrCodeObj = new EcrDefinitionsInfo();
                ecrCodeObj.parse(e);
                this.ecrCodes.push(ecrCodeObj);
            });
        }
    }
}